import React from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';
import { Button, SvgIcon, ThemeProvider, createTheme } from '@mui/material';
import BeerBottelGlassIcon from '../../../icons/BeerBottelGlass.svg?react';
import InputTheme from './Helpers/InputTheme';
import { SelectInput, StyledRadioInput } from '../../Helpers/Inputs';
import getMonth from '../../Helpers/Lists/Months';
import getYear from '../../Helpers/Lists/Years';
import './AlcoholDrugAbuse.scss';

export default function AlcoholDrugAbuse(props) {

  const formMethods = useForm({
    resolver: yupResolver(AlcoholDrugAbuse.ValidationSchema),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState
  });

  const { handleSubmit, trigger } = formMethods;

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
    trigger(field);
  };

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...InputTheme(),
    })}>
      <Container className="alcohol-drug-abuse-form personalize-step">
        <FormProvider {...formMethods}>
          <Form onSubmit={handleSubmit(props.onNext)}>
            <Row className="justify-content-center">
              <Col lg={5}>
                <Row className="justify-content-center pt-2">
                  <div className={`icon-container background-color-16`}>
                    <SvgIcon component={BeerBottelGlassIcon} fontSize="large" color="primary" />
                  </div>
                </Row>
                <Row className="justify-content-center mainTitle">
                  <h4>Alcohol or drug abuse</h4>
                </Row>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={5}>
                <p className="formElementTitle">I was last treated for alcohol/ subtance abuse on</p>
                <Row>
                  <Col lg={6}>
                    <SelectInput
                      name="lastAlcohoSubstandAbuseMonth"
                      id="lastAlcohoSubstandAbuseMonth"
                      value={props.formState.lastAlcohoSubstandAbuseMonth}
                      onChange={(e) => handleValueChange('lastAlcohoSubstandAbuseMonth', e.target.value)}
                      label="Month"
                      selectOptions={getMonth()}
                    />
                  </Col>
                  <Col lg={6}>
                    <SelectInput
                      name="lastAlcohoSubstandAbuseYear"
                      id="lastAlcohoSubstandAbuseYear"
                      value={props.formState.lastAlcohoSubstandAbuseYear}
                      onChange={(e) => handleValueChange('lastAlcohoSubstandAbuseYear', e.target.value)}
                      label="Year"
                      selectOptions={getYear()}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="justify-content-center pt-3">
              <Col lg={5}>
                <p className="formElementTitle">I require treatment</p>
                <StyledRadioInput
                  lable="I require Treatment"
                  name="requireAdditionalAlcoholSubstanceAbuseTreatment"
                  id="requireAdditionalAlcoholSubstanceAbuseTreatment"
                  value={props.formState.requireAdditionalAlcoholSubstanceAbuseTreatment}
                  options={[
                    { value: 'true', label: 'Yes' },
                    { value: 'false', label: 'No' },
                  ]}
                  onChange={(e) => handleValueChange('requireAdditionalAlcoholSubstanceAbuseTreatment', e)}
                  isBlankIcon={true}
                />
              </Col>
            </Row>
            {/* Buttons */}
            <Row className="pre-quote-nav-control">
              <Col className="text-start btn-back">
                <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                  BACK
                </Button>
              </Col>
              <Col className="text-end">
                <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                  NEXT
                </Button>
              </Col>
            </Row>
          </Form>
        </FormProvider>
      </Container>
    </ThemeProvider>
  );
}

AlcoholDrugAbuse.ValidationSchema = object().shape({
  lastAlcohoSubstandAbuseMonth: string().required('Please select the month'),
  lastAlcohoSubstandAbuseYear: string().required('Please select the year'),
  requireAdditionalAlcoholSubstanceAbuseTreatment: string().required('Please choose Yes or No!')
});

AlcoholDrugAbuse.DefaultFormState = (prefill = false, basicInfo = null) => {
  return {
    lastAlcohoSubstandAbuseMonth: '',
    lastAlcohoSubstandAbuseYear: '',
    requireAdditionalAlcoholSubstanceAbuseTreatment: ''
  };
};
